import { Component, OnInit } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl } from '@angular/forms';
import { IMyDpOptions } from 'mydatepicker';

@Component({
  selector: 'app-commerce-appointment-form',
  templateUrl: './commerce-appointment-form.component.html',
  styleUrls: ['./commerce-appointment-form.component.scss']
})
export class CommerceAppointmentFormComponent extends FormBaseComponent<any> implements OnInit {

  private dateOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
  };
  moment

  error = '';
  onDateChanged(data) {
    /*setTimeout(() => {
      this.form.patchValue({ 'date': data.formatted });
    }, 500);*/
  }

  constructor() {
    super();
  }

  ngOnInit() {
    this.init(true);
  }

  template() {
    this.form.addControl('date', new FormControl(''));
    this.form.addControl('time', new FormControl(''));
  }

  controlarHorario(){
    let horario = this.form.get('time').value;
    let hora = parseInt(horario.split(':')[0]);
    if (hora >= 9 && hora <= 19) {
      this.error = '';
    }else{
      this.error = 'El Horario debe ser entre las 9 y las 19';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/commerce-appointment-form/commerce-appointment-form.component.ts